import SwiperCarouselBase from "../utils/swiper_carousel_base"
import { sendSlideImpressionBatch } from "../utils/slide_impression_batch"

const SLIDE_SPEED_MS = 1000

export default class extends SwiperCarouselBase {
  static values = {
    interval: { type: Number, default: 10000 },
    impressionEndpoint: String
  }

  get layoutOptions() {
    return {
      ...super.layoutOptions,
      speed: SLIDE_SPEED_MS
    }
  }

  connect() {
    this.lastImpressionSignature = null
    super.connect()
  }

  swiperReady(swiper) {
    this.recordVisibleSlideImpressions(swiper)
  }

  slideSettled(swiper) {
    this.recordVisibleSlideImpressions(swiper)
  }

  layoutChanged(swiper) {
    requestAnimationFrame(() => this.recordVisibleSlideImpressions(swiper))
  }

  recordVisibleSlideImpressions(swiper) {
    if (!swiper || swiper.destroyed || !this.hasImpressionEndpointValue) return

    const visibleSlides = swiper.visibleSlides.filter((slide) => this.slideTargets.includes(slide))
    if (visibleSlides.length === 0) return

    const signature = visibleSlides.map((slide) => slide.id).join("|")
    if (signature === this.lastImpressionSignature) return

    this.lastImpressionSignature = signature
    this.fireImpressionBatch(visibleSlides)
  }

  fireImpressionBatch(slides) {
    sendSlideImpressionBatch(this.impressionEndpointValue, slides)
  }
}
